"use client";

import React, { useEffect } from "react";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";
import { EmblaOptionsType } from "embla-carousel";
import { companies } from "@/util";

export interface EmblaCarouselProps {
  slides: typeof companies;
  options?: EmblaOptionsType;
}

const EmblaCarousel = ({ slides, options }: EmblaCarouselProps) => {
  const autoplay = Autoplay({ delay: 2000, stopOnInteraction: false });
  const [emblaRef, _] = useEmblaCarousel(options, [autoplay]);

  return (
    <section className="embla relative">
      <div className="embla__viewport" ref={emblaRef}>
        <ul className="embla__container">
          {slides.map(({ id, img, title }) => (
            <li className="embla__slide" key={id}>
              <img
                src={`/companies/${img}`}
                alt={title}
                className="embla__slide__img w-10 md:w-20 h-20 md:h-40 object-contain"
              />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default EmblaCarousel;
